const basicCompany = {
  id: '',
  active: true,
  email: '',
  executiveManagerId: '',
  isNotifiedInsuredUser: false,
  name: '',
  nationalIdentification: '',
  nicoCommissionPercentage: ''
};

export default basicCompany;
